import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-overwrite-draft.hbs';

    var OverwriteDraftDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        ui: {
            submitButton: 'button[type="submit"]'
        },
        events: {
            'submit form': 'onSubmit',
        },
        initialize: function(options) {
            this.callback = options.callback;
            this.destroyOnClose();
        },
        onSubmit: function(e) {
            e.preventDefault();
            this.ui.submitButton.prop('disabled', true);

            if (this.callback) {
                this.callback();
            }
            this.closeDialog();
        }
    });

    export default OverwriteDraftDialog;

